import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { ReunionComponent } from '../reunion/reunion-modal.component';
import { RestClientService } from 'src/app/_core/services/rest-client.service';
import { UtilitiesService } from 'src/app/_core/services/utilities.service';
import {
  catchError,
  finalize,
  forkJoin,
  interval,
  map,
  Observable,
  of,
  Subject,
  Subscription,
  takeUntil,
  timeInterval,
} from 'rxjs';
import { NgBusyModule } from 'ng-busy';
import Swal from 'sweetalert2';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpErrorResponse } from '@angular/common/http';
import { SessionService } from 'src/app/shared/services/sessionStorage.service';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';

import * as FileSaver from 'file-saver';
interface Participant {
  nom: string;
  prenoms: string;
  email: string;
  telephone: string;
  fonction: string;
  organsation: string;
}

interface OrdreJour {
  id: number;
  dateJour: string;
  description: string;
  heureDebut: string;
  heureFin: string;
  libelleSeance: string;
  seanceId: number;
  createdAt: string;
  createdBy: number;
  isDeleted: boolean;
}

interface Reunion {
  libelle: string;
  lieu: string;
  date: string;
  heure: string;
  description: string;
  ordre: string;
  isSeanceMultiple: boolean;
  isPublic: boolean;
  participants?: Participant[];
}

@Component({
  selector: 'app-seance',
  standalone: true,

  imports: [CommonModule, FormsModule, MatPaginatorModule, NgBusyModule],
  templateUrl: './seance.component.html',
  styleUrl: './seance.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SeanceComponent {
  @Input() show: boolean = false;
  @Input() isEditMode: boolean = false;
  @Input() reunionToEdit: Reunion | null = null;
  @Output() closeModale = new EventEmitter<boolean>();

  existingOrdreId: number | null = null;

  actualySubscribed!: Subscription;
  itemsReunions: any;
  itemsRole: any = {};
  itemToSave: any = {};
  dropdownPosition = { top: 0, left: 0 };
  showModalHistorique: boolean = false;
  historiqueItems: any[] = [];
  totalHistorique: number = 0;
  currentSeanceId: number | null = null;
  showDetailModal = false;
  itemsPerPageHistorique = 5;
  currentPageHistorique = 0;
  isEditing: boolean = false;

  itemsDirections: any[] = [];
  selectedHistoriqueItem: any = null;
  statusFilters = [
    { value: '', label: 'Tout' },
    { value: 'EN_ATTENTE', label: 'En attente' },
    { value: 'EN_COURS', label: 'En cours' },
    { value: 'TERMINEE', label: 'Terminée' },
  ];

  applyFilter(status: string) {
    this.itemToSearch.status = status;
    this.getSeance();
  }
  selectedItem: any = {};

  itemToSearch: any = { status: '' };
  searchTerm = '';
  dateFin: string = '';
  dateDebut: string = '';
  activeDropdown: number | null = null;
  totalItems: number = 0;
  totalItemsSeanceMultiple: number = 0;
  itemsPerPage: number = 5;
  currentPage: number = 0;
  showModal: boolean = false;
  currentStep = 0;
  isLoading = false;
  steps = ['Détails', 'Participants', 'Récapitulatif'];
  mode: 'create' | 'edit' = 'create';
  longitudeError: boolean = false;
  editingIndex: any;
  currentUser: any;
  reunion: any = {
    libelle: '',
    description: '',
    lieu: '',
    longitudeLieu: '',
    latitudeLieu: '',
    ordreDuJour: '',
    rayonValidite: '',
    typeSeance: '',
    date: '',
    heure: '',
    firstDate: '',
    lastDate: '',
    directionId: 0,
    heureDebut: '',
    heureFin: '',
    isPublic: false,
    ordre: '',
    isSeanceMultiple: false,
  };
  isSeanceMultiple = false;
  isPublic = false;
  seances: any[] = [];

  totalDirections: number = 0;
  backupData: any = {};

  ordre: any = {
    seanceId: null,
    dateJour: '',
    description: '',
    heureDebut: '',
    heureFin: '',
  };
  sendingInvitations = false;
  participants: any[] = [];
  showAddParticipantForm = false;
  showaddMultipleSeanceForm = false;
  newParticipant: any = {
    nom: '',
    prenoms: '',
    email: '',
    telephone: '',
    fonction: '',
    societe: '',
    isMail: false,
    editing: false,
  };
  activeActionMenu: any = null;
  menuPosition = { x: 0, y: 0 };

  multiple: any;

  loading = false;

  private destroy$ = new Subject<void>();
  paginatorIntl: any;
  ordresDuJour: any[] = [];
  TotalEnAttente: any[] = [];
  Total: any[] = [];
  TotalEnCours: any[] = [];
  TotalTermines: any[] = [];
  isLoadingDetail: boolean = false;
  showModalSeanceMultiple = false;
  reunionSaved: any = {};
  constructor(
    private restClient: RestClientService,
    private utilitiesService: UtilitiesService,
    private cdr: ChangeDetectorRef,

    private sessionStorage: SessionService,
    private sanitizer: DomSanitizer
  ) {}

  onPrenomChange(value: string) {
    this.newParticipant.prenoms = value.slice(0, 10);
  }
  validateLongitudeInput(event: KeyboardEvent): boolean {
    const allowedKeys = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '.',
      '-',
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
    ];

    const currentValue = (event.target as HTMLInputElement).value;
    const key = event.key;

    if (!allowedKeys.includes(key)) {
      event.preventDefault();
      return false;
    }

    if (key === '-' && currentValue.length > 0) {
      event.preventDefault();
      return false;
    }

    if (key === '.' && currentValue.includes('.')) {
      event.preventDefault();
      return false;
    }

    return true;
  }

  validateLongitudePaste(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text');
    if (pastedData && !/^-?[\d.]*$/.test(pastedData)) {
      event.preventDefault();
    }
  }

  hasParticipantsWithEmail(): boolean {
    console.log('Vérification participants avec email:', this.participants);
    const participantsWithEmail = this.participants.filter(p => {
      const hasEmail = p.email?.trim();
      const wantsEmail = p.isMail === true;
      console.log(`Participant ${p.nom}: email=${hasEmail}, isMail=${wantsEmail}`);
      return hasEmail && wantsEmail;
    });
    console.log('Participants avec email et isMail=true:', participantsWithEmail);
    return participantsWithEmail.length > 0;
  }


  sendInvitations(): void {
    if (!this.itemToSave?.id) {
      this.utilitiesService.showNotification(
        'Aucune réunion à traiter',
        'error'
      );
      return;
    }

    const participantsEmails = this.participants
      .filter((p) => p.email?.trim() && p.isMail)
      .map((p) => p.email.trim());

    if (participantsEmails.length === 0) {
      this.utilitiesService.showNotification(
        'Aucun participant avec email à inviter'
      );
      return;
    }

    this.sendingInvitations = true;

    const requestData = {
      data: {
        id: this.itemToSave.id,
        participantsEmails: participantsEmails,
      },
    };

    console.log('Envoi des invitations:', requestData);

    this.restClient
      .post('seance/inviteParticipants', requestData)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.sendingInvitations = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: (res: any) => {
          console.log('Réponse invitations:', res);
          if (!res.hasError) {
            this.utilitiesService.showNotification(
              `Invitations envoyées avec succès à ${participantsEmails.length} participant(s)`,
              'success'
            );
          } else {
            const errorMessage =
              res.status?.message || "Erreur lors de l'envoi des invitations";
            this.utilitiesService.showNotification(errorMessage, 'error');
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error('Erreur envoi invitations:', err);
          let errorMessage = "Erreur lors de l'envoi des invitations";

          if (err.error?.status?.message) {
            errorMessage = err.error.status.message;
          } else if (err.error?.message) {
            errorMessage = err.error.message;
          } else if (err.message) {
            errorMessage = err.message;
          }

          this.utilitiesService.showNotification(errorMessage, 'error');
        },
      });
  }

  imageError = false;

  handleImageError() {
    console.error('Error loading QR code image:', this.reunion.lienQrCode);
    this.imageError = true;
  }

  ngOnInit(): void {
    // console.log('selectedItem:', this.selectedItem);
    // console.log('reunion:', this.reunion);

    this.currentUser = JSON.parse(
      sessionStorage.getItem('currentUser') || '{}'
    );

    this.actualySubscribed = interval(10000).subscribe(() => {
      this.getSeance();
    });

    this.getSeance();
    interval(5000).subscribe(() => {
      this.initializeData();
    });
    this.initializeData();
  }

  
  confirmValidation(seanceId: number) {
  Swal.fire({
    title: 'Confirmation',
    text: 'Voulez-vous vraiment valider cette séance ?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Oui, valider',
    cancelButtonText: 'Annuler',
    iconColor: '#fb923c',
    customClass: {
      confirmButton: 'btn-confirm-orange',
      cancelButton: 'btn-cancel-black',
    },
    buttonsStyling: false, // désactive le style 
  }).then((result) => {
    if (result.isConfirmed) {
      this.validerModal(seanceId);
    }
  });
}


  setStatus(status: string) {
    this.itemToSearch.status = status;
    this.getSeance();
  }
  private initializeData(): void {
    forkJoin({
      // seances: this.getSeance(),
      //multipleSeances: this.getMultipleSeance(),

      enAttente: this.getSeanceEnAttente(),
      enCours: this.getSeanceEnCours(),
      total: this.getSeanceTotal(),
      terminees: this.getSeanceTerminees(),
    })
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.isLoading = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: (result) => {
          // console.log('Toutes les données ont été chargées');
          this.cdr.markForCheck();
        },
        error: (err) => {
          console.error('Erreur lors du chargement des données:', err);
          this.utilitiesService.showNotification(
            "Une erreur s'est produite lors du chargement initial des données",
            'error'
          );
        },
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.actualySubscribed.unsubscribe();
  }

  downloadQRCode(seanceId: number): void {
    if (this.isLoading) return;

    this.isLoading = true;
    this.cdr.markForCheck();

    const token =
      localStorage.getItem('auth_token') || sessionStorage.getItem('token');

    const request = {
      user: this.currentUser.id,
      isSimpleLoading: false,
      data: {
        id: seanceId,
      },
    };

    const apiUrl =
      'https://fichepresence.oneci.ci/api/api-fiche-presence/seance/downloadQrCode';

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify(request),
    };

    const timeoutDuration = 30000;
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error('Timeout dépassé')), timeoutDuration);
    });

    Promise.race([fetch(apiUrl, requestOptions), timeoutPromise])
      .then((response: any) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data && data.item && data.item.qrCodeBytes) {
          const base64Data = data.item.qrCodeBytes;
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'image/png' });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;

          const fileName = data.item.lienQrCode || `qr_code_${seanceId}.png`;
          link.download = fileName;

          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();

          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 500);

          this.utilitiesService.showNotification(
            'QR Code téléchargé avec succès',
            'success'
          );
        } else {
          throw new Error('Données QR Code non trouvées dans la réponse');
        }
      })
      .catch((error) => {
        console.error('Erreur lors du téléchargement:', error);
        this.utilitiesService.showNotification(
          `Erreur lors du téléchargement: ${error.message}`,
          'error'
        );
      })
      .finally(() => {
        this.isLoading = false;
        this.cdr.markForCheck();
      });
  }

  downloadPresencePdf(seanceId: number): void {
  if (this.isLoading) return;

  this.isLoading = true;
  this.cdr.markForCheck();

  const token =
    localStorage.getItem('auth_token') || sessionStorage.getItem('token');

  const request = {
    user: this.currentUser.id,
    isSimpleLoading: false,
    data: {
      user: this.currentUser.id,
      id: seanceId,
    },
  };

  const apiUrl =
    'https://fichepresence.oneci.ci/api/api-fiche-presence/seance/downloadPresencePdf';

  const controller = new AbortController();
  const timeout = setTimeout(() => {
    controller.abort();
  }, 30000);

  fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify(request),
    signal: controller.signal,
  })
    .then(async (response) => {
      clearTimeout(timeout);

      const contentType = response.headers.get('Content-Type') || '';

      console.log('HTTP Status:', response.status);
      console.log('Content-Type:', contentType);

      if (contentType.includes('application/json')) {
        const errorData = await response.json();

        console.error('Erreur API:', errorData);

        throw new Error(
          errorData?.status?.message ||
          'Une erreur est survenue lors du téléchargement du PDF.'
        );
      }

      if (contentType.includes('application/pdf')) {
        return response.blob();
      }

      throw new Error(
        `Type de réponse inattendu : ${contentType || 'inconnu'}`
      );
    })
    .then((blob) => {
      console.log('PDF reçu:', blob);
      console.log('Taille:', blob.size);
      console.log('Type:', blob.type);

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `presence_${seanceId}.pdf`;
      link.style.display = 'none';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 500);
    })
    .catch((error) => {
      clearTimeout(timeout);

      let message = error.message;

      if (error.name === 'AbortError') {
        message = 'Le téléchargement a dépassé le délai de 30 secondes.';
      }

      console.error('Erreur lors du téléchargement:', error);

      this.utilitiesService.showNotification(
        message,
        'error'
      );
    })
    .finally(() => {
      clearTimeout(timeout);

      this.isLoading = false;
      this.cdr.markForCheck();
    });
}
  validateNumberInput(event: KeyboardEvent): void {
    const allowedKeys = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
    ];

    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  validateNumberPaste(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text');
    if (pastedData && !/^\d+$/.test(pastedData)) {
      event.preventDefault();
    }
  }

  onPaste(event: ClipboardEvent): void {
    const pastedText = event.clipboardData?.getData('text');
    if (pastedText && !/^-?\d*\.?\d+$/.test(pastedText)) {
      event.preventDefault();
      this.longitudeError = true;
    } else {
      this.longitudeError = false;
    }
  }
  getDefaultReunion(): any {
    return {
      libelle: '',
      description: '',
      lieu: '',
      longitudeLieu: '',
      latitudeLieu: '',
      ordreDuJour: '',
      rayonValidite: '',
      firstDate: '',
      lastDate: '',
      typeSeance: '',
      date: '',
      heure: '',
      directionId: 0,
      heureDebut: '',
      heureFin: '',
      isPublic: false,
      ordre: '',
      isSeanceMultiple: false,
    };
  }

  getDefaultParticipant(): any {
    return {
      nom: '',
      prenoms: '',
      email: '',
      telephone: '',
      fonction: '',
      societe: '',
    };
  }

  downloadPresenceExcel(seanceId: number) {
  this.isLoading = true;

  const token =
    localStorage.getItem('auth_token') || sessionStorage.getItem('token');

  const request = {
    user: this.currentUser.id,
    isSimpleLoading: false,
    data: {
      id: seanceId,
      user: this.currentUser.id,
    },
  };

  const apiUrl =
    'https://fichepresence.oneci.ci/api/api-fiche-presence/seance/downloadPresenceExcel';

  fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify(request),
  })
    .then(async (response) => {
      const contentType = response.headers.get('Content-Type') || '';

      console.log('HTTP Status:', response.status);
      console.log('Content-Type:', contentType);

   
      if (contentType.includes('application/json')) {
        const errorData = await response.json();

        console.error('Erreur API:', errorData);

        throw new Error(
          errorData?.status?.message ||
          'Une erreur est survenue lors du téléchargement.'
        );
      }

      if (
        contentType.includes('application/pdf') ||
        contentType.includes(
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ) ||
        contentType.includes('application/vnd.ms-excel')
      ) {
        return response.blob();
      }

      throw new Error(
        `Type de réponse inattendu : ${contentType || 'inconnu'}`
      );
    })
    .then((blob) => {
      console.log('Fichier reçu:', blob);
      console.log('Taille:', blob.size);
      console.log('Type:', blob.type);

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `presence_${seanceId}.xlsx`;
      link.style.display = 'none';

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error(
        'Erreur lors du téléchargement Excel:',
        error
      );

      // Afficher le message à l'utilisateur
      // Exemple avec ton système de notification :
      // this.toastService.error(error.message);

      alert(error.message);
    })
    .finally(() => {
      this.isLoading = false;
      this.cdr.markForCheck();
    });
}
  getDirection() {
    this.isLoading = true;
    const request = {
      index: this.currentPage,
      size: this.itemsPerPage,
      isSimpleLoading: false,
      user: this.currentUser.id,
      data: {
        nom: this.itemToSearch.nom || '',
      },
    };

    this.restClient
      .post('directions/getByCriteria', request)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (res: any) => {
          // console.log('Réponse API Users:', res);
          this.totalDirections = res.count;
          // console.log('totalUser', this.totalDirections);

          this.itemsDirections = res?.items?.length > 0 ? res.items : [];
          this.cdr.markForCheck();
        },
        error: (err) => {
          console.error('Erreur lors de la récupération des Directions:', err);
          this.itemsDirections = [];
        },
      });

    this.cdr.markForCheck();
  }

  nextStep(): void {
    if (this.validateCurrentStep()) {
      this.currentStep++;
      this.cdr.markForCheck();
    }
  }

  openDetailModal(item: any) {
    this.activeDropdown = null;
    this.selectedItem = item;

    // console.log('Item sélectionné pour le modal:', item);

    if (!item || !item.id) {
      console.error("Impossible d'ouvrir le modal: ID de séance manquant");
      this.utilitiesService.showNotification(
        "Erreur: Impossible d'identifier la séance",
        'error'
      );
      return;
    }

    this.loadSeanceDetails(item.id);
  }

  onSeanceMultipleChange(isMultiple: boolean) {
    if (isMultiple) {
      // Si la séance devient multiple, on vide le champ "date"
      this.reunion.date = null;
    } else {
      // Si la séance devient simple, on vide les champs "dateDebut" et "dateFin"
      this.reunion.dateDebut = null;
      this.reunion.dateFin = null;
    }
  }
  formatDescription(description: string | null | undefined): SafeHtml {
    if (!description) return this.sanitizer.bypassSecurityTrustHtml('-');
    return this.sanitizer.bypassSecurityTrustHtml(
      description.replace(/\n/g, '<br>')
    );
  }
  loadSeanceDetails(seanceId: number) {
    this.isLoadingDetail = true;

    const requestOrdre = {
      user: this.currentUser.id,
      data: {
        seanceId: seanceId,
      },
      isSimpleLoading: false,
      index: 0,
      size: 10,
    };

    console.log('Requête ordre du jour:', requestOrdre);

    this.restClient
      .post('ordre-du-jour/getByCriteria', requestOrdre)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.isLoadingDetail = false;
        })
      )
      .subscribe({
        next: (result: any) => {
          console.log('Résultat ordre du jour:', result);
          this.ordresDuJour = result?.items || [];

          this.showDetailModal = true;
          this.cdr.markForCheck();
        },
        error: (err) => {
          console.error("Erreur lors du chargement de l'ordre du jour:", err);
          this.utilitiesService.showNotification(
            "Impossible de charger l'ordre du jour",
            'error'
          );
        },
      });
  }

  private getSeanceEnAttente(): Observable<any> {
    const request = {
      user: this.currentUser.id,
      data: {
        //directionId: this.currentUser.directionId
      },
      isSimpleLoading: false,
      index: 0,
      size: 10,
    };

    return this.restClient.post('seance/count/en-attente', request).pipe(
      catchError((err) => {
        console.error('Erreur lors du chargement du total en attente:', err);
        return of(null);
      }),
      map((result: any) => {
        if (result) {
          this.TotalEnAttente = result?.item || 0;
        }
        return result;
      })
    );
  }

  private getSeanceTotal(): Observable<any> {
    const request = {
      user: this.currentUser.id,
      data: {
        // directionId: this.currentUser.directionId
      },
      isSimpleLoading: false,
      index: 0,
      size: 10,
    };

    return this.restClient.post('seance/count/total', request).pipe(
      catchError((err) => {
        console.error('Erreur lors du chargement du total en attente:', err);
        return of(null);
      }),
      map((result: any) => {
        if (result) {
          this.Total = result?.item || 0;
        }
        return result;
      })
    );
  }

  private getSeanceTerminees(): Observable<any> {
    const request = {
      user: this.currentUser.id,
      data: {
        //   directionId: this.currentUser.directionId
      },
      isSimpleLoading: false,
      index: 0,
      size: 10,
    };

    return this.restClient.post('seance/count/terminees', request).pipe(
      catchError((err) => {
        console.error('Erreur lors du chargement du total terminées:', err);
        return of(null);
      }),
      map((result: any) => {
        if (result) {
          this.TotalTermines = result?.item || 0;
        }
        return result;
      })
    );
  }
  private getSeanceEnCours(): Observable<any> {
    const request = {
      user: this.currentUser.id,
      data: {
        //directionId: this.currentUser.directionId,
      },
      isSimpleLoading: false,
      index: 0,
      size: 10,
    };

    return this.restClient.post('seance/count/en-cours', request).pipe(
      catchError((err) => {
        console.error('Erreur lors du chargement du total en cours:', err);
        return of(null);
      }),
      map((result: any) => {
        if (result) {
          this.TotalEnCours = result?.item || 0;
        }
        return result;
      })
    );
  }

  openTraiterModal(item: any) {}
  openHistoriqueModal(seanceId?: number) {
    this.activeDropdown = null;
    this.loading = true;

    console.log('ID demande à consulter:', seanceId);

    const request = {
      user: this.currentUser.id,
      data: seanceId ? { seanceId: seanceId } : {},
      isSimpleLoading: false,
      locale: 'fr',
      size: 100,
      index: 0,
    };

    console.log('Requête historique:', request);

    this.restClient.post('presence/getByCriteria', request).subscribe({
      next: (res) => {
        this.loading = false;
        console.log('Réponse API:', res);
        if (!res.hasError) {
          this.historiqueItems = res.items;
          this.totalHistorique = res.count;
          this.selectedHistoriqueItem = { seanceId: seanceId };
          this.showModalHistorique = true;
        } else {
          this.utilitiesService.showNotification(
            "Une erreur s'est produite lors de la récupération de l'historique",
            'error'
          );
        }
        this.cdr.markForCheck();
      },
      error: (err) => {
        console.error('Erreur:', err);
        this.loading = false;
        this.utilitiesService.showNotification(
          "Une erreur inattendue s'est produite",
          'error'
        );
      },
    });
  }

  validerModal(seanceId?: number) {
    const request = {
      user: this.currentUser.id,
      data: { id: seanceId },
      isSimpleLoading: false,
      locale: 'fr',
      size: 100,
      index: 0,
    };

    console.log('Requête historique:', request);

    this.restClient.post('seance/validateSeance', request).subscribe({
      next: (res) => {
        this.loading = false;
        console.log('Réponse API:', res);
        if (!res.hasError) {
          this.historiqueItems = res.items;
          this.totalHistorique = res.count;
          this.selectedHistoriqueItem = { seanceId: seanceId };
          this.showModalHistorique = true;
        } else {
          this.utilitiesService.showNotification(
            "Une erreur s'est produite lors de la récupération de l'historique",
            'error'
          );
        }
        this.cdr.markForCheck();
      },
      error: (err) => {
        console.error('Erreur:', err);
        this.loading = false;
        this.utilitiesService.showNotification(
          "Une erreur inattendue s'est produite",
          'error'
        );
      },
    });
  }

  exportFichierPdf(seanceId?: number) {
    this.activeDropdown = null;
    this.loading = true;

    console.log('ID demande à consulter:', seanceId);

    const request = {
      user: this.currentUser.id,
      data: seanceId ? { seanceId: seanceId } : {},
      isSimpleLoading: false,
      locale: 'fr',
      size: 100,
      index: 0,
    };

    console.log('Requête historique:', request);

    this.restClient.post('presence/getByCriteria', request).subscribe({
      next: (res) => {
        this.loading = false;
        console.log('Réponse API:', res);
        if (!res.hasError) {
          this.historiqueItems = res.items;
          this.totalHistorique = res.count;
          this.selectedHistoriqueItem = { seanceId: seanceId };
          this.showModalHistorique = true;
        } else {
          this.utilitiesService.showNotification(
            "Une erreur s'est produite lors de la récupération de l'historique",
            'error'
          );
        }
        this.cdr.markForCheck();
      },
      error: (err) => {
        console.error('Erreur:', err);
        this.loading = false;
        this.utilitiesService.showNotification(
          "Une erreur inattendue s'est produite",
          'error'
        );
      },
    });
  }

  toggleDropdown(item: any) {
    this.activeDropdown = this.activeDropdown === item ? null : item;
  }

  openModifModal(item: any) {
    this.activeDropdown = null;

    if (!item) {
      console.error('Item manquant');
      return;
    }

    // console.log('Item pour modification:', item);

    if (!item.id && item.seanceId) {
      console.log('Utilisation de seanceId à la place de id');
      item.id = item.seanceId;
    }

    this.openModal(item);
  }

  Openseances(item: any) {
    this.activeDropdown = null;
    this.currentSeanceId = item.id;
    this.showModalSeanceMultiple = true;

    this.ordre = {
      seanceId: item.id,
      dateJour: '',
      description: '',
      heureDebut: '',
      heureFin: '',
    };

    this.seances = [];
    this.isEditMode = false;
    this.existingOrdreId = null;

    this.loadExistingOrdreJour(item.id);
  }

  loadExistingOrdreJour(seanceId: number) {
    this.loading = true;

    const requestData = {
      data: {
        seanceId: seanceId,
      },
      user: 9,
      isSimpleLoading: false,
      index: 0,
      size: 10,
    };
    console.log('SeanceId:', seanceId),
      this.restClient
        .post('ordre-du-jour/getByCriteria', requestData)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            this.loading = false;
            this.cdr.markForCheck();
          })
        )
        .subscribe({
          next: (res: any) => {
            console.log('Réponse API getByCriteria:', res);
            if (!res.hasError && res.items && res.items.length > 0) {
              this.isEditMode = true;

              this.seances = res.items.map((item: any) => ({
                id: item.id,
                seanceId: item.seanceId,
                dateJour: this.parseApiDateAsString(item.dateJour),
                description: item.description,
                heureDebut: item.heureDebut,
                heureFin: item.heureFin,
                libelleSeance: item.libelleSeance,
              }));

              this.ordre = {
                seanceId: seanceId,
                dateJour: '',
                description: '',
                heureDebut: '',
                heureFin: '',
              };

              console.log('Données chargées:', this.seances);
            } else {
              this.isEditMode = false;
              this.seances = [];
              console.log('Aucune donnée trouvée, mode création activé');
            }
          },
          error: (err) => {
            console.error('Erreur lors du chargement:', err);
            this.isEditMode = false;
            this.seances = [];
            this.utilitiesService.showNotification(
              'Erreur lors du chargement des données existantes',
              'error'
            );
          },
        });
  }

  parseApiDateAsString(dateString: string): string {
    if (!dateString) return '';

    try {
      if (dateString.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
        return dateString;
      }
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      }

      return dateString;
    } catch (error) {
      console.error('Erreur lors du parsing de la date:', error);
      return dateString;
    }
  }

  addMultipleSeance() {
    if (
      !this.ordre.dateJour ||
      !this.ordre.heureDebut ||
      !this.ordre.heureFin
    ) {
      this.utilitiesService.showNotification(
        'Veuillez remplir tous les champs obligatoires',
        'error'
      );
      return;
    }

    const dateForDisplay = this.convertYYYYMMDDtoDDMMYYYY(this.ordre.dateJour);

    if (this.isEditing && this.editingIndex !== null) {
      this.seances[this.editingIndex] = {
        ...this.seances[this.editingIndex],
        dateJour: dateForDisplay,
        description: this.ordre.description,
        heureDebut: this.ordre.heureDebut,
        heureFin: this.ordre.heureFin,
      };

      this.utilitiesService.showNotification(
        'Séance modifiée avec succès',
        'success'
      );
      this.resetForm();
    } else if (this.existingOrdreId) {
      const index = this.seances.findIndex(
        (s) => s.id === this.existingOrdreId
      );
      if (index !== -1) {
        this.seances[index] = {
          ...this.seances[index],
          dateJour: dateForDisplay,
          description: this.ordre.description,
          heureDebut: this.ordre.heureDebut,
          heureFin: this.ordre.heureFin,
        };
      }

      this.resetForm();
    } else {
      const newSeance = {
        id: null,
        seanceId: this.ordre.seanceId,
        dateJour: dateForDisplay,
        description: this.ordre.description,
        heureDebut: this.ordre.heureDebut,
        heureFin: this.ordre.heureFin,
      };

      if (this.isEditMode) {
        this.saveNewSeanceDirectly(newSeance);
      } else {
        this.seances.push(newSeance);
        this.utilitiesService.showNotification(
          'Séance ajoutée avec succès',
          'success'
        );
        this.resetForm();
      }
    }
  }

  resetForm() {
    this.ordre = {
      dateJour: '',
      description: '',
      heureDebut: '',
      heureFin: '',
      seanceId: this.currentSeanceId,
    };
    this.existingOrdreId = null;
    this.editingIndex = null;
    this.isEditing = false;
  }

  validateSeanceData(): boolean {
    if (!this.ordre.dateJour) {
      this.utilitiesService.showNotification('La date est requise', 'error');
      return false;
    }
    if (!this.ordre.heureDebut || !this.ordre.heureFin) {
      this.utilitiesService.showNotification(
        'Les horaires sont requis',
        'error'
      );
      return false;
    }
    return true;
  }

  convertDDMMYYYYtoYYYYMMDD(dateString: string): string {
    if (!dateString) return '';

    try {
      if (dateString.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
        const parts = dateString.split('/');
        const day = parts[0];
        const month = parts[1];
        const year = parts[2];
        return `${year}-${month}-${day}`;
      }

      return dateString;
    } catch (error) {
      console.error('Erreur lors de la conversion de date:', error);
      return '';
    }
  }
  editSeance(seance: any, index: number) {
    this.ordre = {
      dateJour: this.convertDDMMYYYYtoYYYYMMDD(seance.dateJour),
      description: seance.description,
      heureDebut: seance.heureDebut,
      heureFin: seance.heureFin,
      seanceId: seance.seanceId,
    };

    this.existingOrdreId = seance.id;
    this.editingIndex = index;
    this.isEditing = true;
  }

  convertYYYYMMDDtoDDMMYYYY(dateString: string): string {
    if (!dateString) return '';

    try {
      if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const parts = dateString.split('-');
        const year = parts[0];
        const month = parts[1];
        const day = parts[2];
        return `${day}/${month}/${year}`;
      }

      return dateString;
    } catch (error) {
      console.error('Erreur lors de la conversion de date:', error);
      return dateString;
    }
  }

  formatTime(time: string): string {
    if (!time) return '00:00:00';
    return time.includes(':')
      ? time.split(':').length === 2
        ? `${time}:00`
        : time
      : '00:00:00';
  }

  private getMultipleSeance(): Observable<any> {
    const request = {
      user: this.currentUser.id,
      data: {},
    };

    return this.restClient.post('ordre-du-jour/getByCriteria', request).pipe(
      catchError((err) => {
        console.error(
          'Erreur lors de la récupération des séances multiples:',
          err
        );
        this.seances = [];
        this.totalItemsSeanceMultiple = 0;
        return of(null);
      }),
      map((res: any) => {
        if (res) {
          this.totalItemsSeanceMultiple = res.count || 0;
          this.seances = res?.items?.length > 0 ? res.items : [];
        }
        return res;
      })
    );
  }




  confirmDelete(id: number) {
    Swal.fire({
      title: 'Confirmation',
      text: 'Voulez-vous vraiment supprimer cette réunion ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f97316',
      cancelButtonColor: '#000',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.deleteItem(id);
      }
    });
  }

  showDetailWithData(item: any) {
    this.selectedItem = item;
    this.isLoadingDetail = true;

    const seanceId = item.id;

    const requestSeance = {
      user: this.currentUser.id,
      data: {
        id: seanceId,
      },
      isSimpleLoading: false,
      index: 0,
      size: 1,
    };

    const requestOrdre = {
      user: this.currentUser.id,
      data: {
        seanceId: seanceId,
      },
      isSimpleLoading: false,
      index: 0,
      size: 10,
    };
    console.log('Requête ordre du jour:', requestOrdre);

    forkJoin({
      seance: this.restClient.post('seance/getByCriteria', requestSeance),
      ordreJour: this.restClient.post(
        'ordre-du-jour/getByCriteria',
        requestOrdre
      ),
    })
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.isLoadingDetail = false;
        })
      )
      .subscribe({
        next: (result: any) => {
          if (result.seance?.items?.length > 0) {
            this.selectedItem = {
              ...this.selectedItem,
              ...result.seance.items[0],
            };
          }
          console.log(
            "Résultat brut de l'API ordre du jour:",
            result.ordreJour
          );
          console.log('ID de séance sélectionnée:', seanceId);
          console.log('Ordres du jour filtrés:', this.ordresDuJour);
          this.ordresDuJour =
            result.ordreJour?.items?.filter(
              (item: any) => item.seanceId === seanceId
            ) || [];

          console.log(
            `Ordres du jour pour séance ${seanceId}:`,
            this.ordresDuJour
          );

          this.showDetailModal = true;
          this.cdr.markForCheck();
        },
        error: (err) => {
          console.error('Erreur lors du chargement des détails:', err);
          this.utilitiesService.showNotification(
            'Impossible de charger les détails de la réunion',
            'error'
          );
        },
      });
  }
  removeSeance(index: number, seanceId: number) {
    if (seanceId) {
      Swal.fire({
        title: 'Confirmation',
        text: 'Êtes-vous sûr de vouloir supprimer cette séance ?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Oui, supprimer',
        cancelButtonText: 'Annuler',
        confirmButtonColor: '#ff9500',
        cancelButtonColor: '#6c757d',
      }).then((result) => {
        if (result.isConfirmed) {
          this.seances.splice(index, 1);
          this.deleteOrdreDuJour(seanceId);
        }
      });
    } else {
      this.seances.splice(index, 1);
    }
  }

  deleteOrdreDuJour(id: number) {
    this.activeDropdown = null;

    this.loading = true;

    const requestData = {
      datas: [{ id: id }],
      user: this.currentUser.id,
      isSimpleLoading: false,
    };

    this.restClient
      .post('ordre-du-jour/delete', requestData)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: (res: any) => {
          if (!res.hasError) {
            this.utilitiesService.showNotification(
              'Séance supprimée avec succès',
              'success'
            );

            this.getSeance();
          } else {
            this.utilitiesService.showNotification(
              "Une erreur s'est produite lors de la suppression",
              'error'
            );
          }
        },
        error: (err: any) => {
          console.error('Erreur:', err);
          this.utilitiesService.showNotification(
            "Une erreur inattendue s'est produite",
            'error'
          );
        },
      });
  }

  deleteItem(id: number) {
    this.activeDropdown = null;

    this.loading = true;

    const requestData = {
      datas: [{ id: id }],
      user: this.currentUser.id,
      isSimpleLoading: false,
    };

    this.restClient
      .post('seance/delete', requestData)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: (res: any) => {
          if (!res.hasError) {
            this.utilitiesService.showNotification(
              'Séance supprimée avec succès',
              'success'
            );

            this.getSeance();
          } else {
            this.utilitiesService.showNotification(
              "Une erreur s'est produite lors de la suppression",
              'error'
            );
          }
        },
        error: (err: any) => {
          console.error('Erreur:', err);
          this.utilitiesService.showNotification(
            "Une erreur inattendue s'est produite",
            'error'
          );
        },
      });
  }
  prevStep(): void {
    this.currentStep--;
    this.cdr.markForCheck();
  }
  pageChanged(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.getSeance();
  }

  pageChangedHistorique(event: PageEvent) {
    this.currentPageHistorique = event.pageIndex;
    this.itemsPerPageHistorique = event.pageSize;
  }
  getPaginatedHistorique() {
    if (!this.historiqueItems) return [];
    const start = this.currentPageHistorique * this.itemsPerPageHistorique;
    return this.historiqueItems.slice(
      start,
      start + this.itemsPerPageHistorique
    );
  }
  closeModalHistorique() {
    this.showModalHistorique = false;
    this.historiqueItems = [];
    this.selectedHistoriqueItem = null;
  }
  closeModalSeanceMultiple() {
    this.showModalSeanceMultiple = false;
  }
  validateCurrentStep(): boolean {
    switch (this.currentStep) {
      case 0:
        const champsManquants: string[] = [];

        if (!this.reunion.libelle) {
          champsManquants.push('libellé');
        }
        if (!this.reunion.lieu) {
          champsManquants.push('lieu');
        }
        if (
          !this.reunion.date &&
          !(this.reunion.firstDate && this.reunion.lastDate)
        ) {
          const champDate = this.reunion.isSeanceMultiple
            ? 'dates de début et fin'
            : 'date';
          champsManquants.push(champDate);
        }
        if (!this.reunion.heureDebut) {
          champsManquants.push('heure de début');
        }
        if (!this.reunion.heureFin) {
          champsManquants.push('heure de fin');
        }
        if (!this.reunion.typeSeance) {
          champsManquants.push('type de séance');
        }

        if (champsManquants.length > 0) {
          this.utilitiesService.showNotification(
            `Veuillez remplir les champs suivants : ${champsManquants.join(
              ', '
            )}`,
            'error'
          );
          return false;
        }

        // Vérification que l'heure de fin est après l'heure de début
        const [debutHours, debutMinutes] = this.reunion.heureDebut.split(':');
        const [finHours, finMinutes] = this.reunion.heureFin.split(':');

        const debutTotal = parseInt(debutHours) * 60 + parseInt(debutMinutes);
        const finTotal = parseInt(finHours) * 60 + parseInt(finMinutes);

        if (debutTotal >= finTotal) {
          this.utilitiesService.showNotification(
            "L'heure de fin doit être après l'heure de début",
            'error'
          );
          return false;
        }

        return true;

      case 1: // Participants
        return true;

      default:
        return true;
    }
  }

  closeDetailModal() {
    this.showDetailModal = false;
  }

  openModal(item?: any): void {
    // console.log('=== DÉBUT openModal ===');
    // console.log('Item reçu:', item);
    // console.log('Participants AVANT nettoyage:', [...this.participants]);

    this.showModal = true;
    this.currentStep = 0;

    this.participants = [];
    this.newParticipant = {
      nom: '',
      prenoms: '',
      email: '',
      telephone: '',
      fonction: '',
      societe: '',
      isMail: false,
      editing: false,
    };
    this.showAddParticipantForm = false;

    // console.log('Participants APRÈS nettoyage initial:', [
    //   ...this.participants,
    // ]);

    if (item) {
      this.isEditMode = true;

      let formattedDate = '';
      if (item.date || item.firstDate || item.lastDate) {
        const dateParts = item.date.split('/');
        if (dateParts.length === 3) {
          formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
        } else {
          formattedDate = item.date;
        }
      }

      this.reunion = {
        id: item.id,
        libelle: item.libelle || '',
        description: item.description || '',
        lieu: item.lieu || '',
        longitudeLieu: item.longitudeLieu || '',
        firstDate: formattedDate,
        lastDate: formattedDate,
        latitudeLieu: item.latitudeLieu || '',
        date: formattedDate,
        typeSeance: item.typeSeance || '',
        rayonValidite: item.rayonValidite || 0,
        heureDebut: item.heureDebut || '',
        heureFin: item.heureFin || '',
        directionId: this.currentUser.directionId,
        ordreDuJour: item.ordreDuJour || '',
        isSeanceMultiple: item.isSeanceMultiple || false,
        isPublic: item.isPublic || false,
      };

      // console.log('item.participants brut:', item.participants);
      // console.log('Type de item.participants:', typeof item.participants);
      // console.log('Est-ce un array?', Array.isArray(item.participants));

      if (item.participants && Array.isArray(item.participants)) {
        // console.log('Nombre de participants dans item:', item.participants.length);

        const cleanParticipants = item.participants
          .filter((p: any, index: number) => {
            console.log(`Participant ${index}:`, p);
            const isDuplicate =
              item.participants.findIndex((other: any, otherIndex: number) => {
                if (otherIndex >= index) return false;

                if (
                  p.email &&
                  other.email &&
                  p.email.toLowerCase().trim() ===
                    other.email.toLowerCase().trim()
                ) {
                  return true;
                }

                if (
                  p.nom &&
                  p.prenoms &&
                  other.nom &&
                  other.prenoms &&
                  p.nom.toLowerCase().trim() ===
                    other.nom.toLowerCase().trim() &&
                  p.prenoms.toLowerCase().trim() ===
                    other.prenoms.toLowerCase().trim()
                ) {
                  return true;
                }

                return false;
              }) !== -1;

            if (isDuplicate) {
              console.log(`Participant ${index} éliminé (doublon):`, p);
            }

            return !isDuplicate;
          })
          .map((p: any) => ({
            nom: (p.nom || '').toString().trim(),
            prenoms: (p.prenoms || '').toString().trim(),
            email: (p.email || '').toString().trim(),
            telephone: (p.telephone || '').toString().trim(),
            fonction: (p.fonction || '').toString().trim(),
            societe: (p.societe || '').toString().trim(),
            editing: false,
          }));

        // console.log('Participants nettoyés:', cleanParticipants);
        this.participants = cleanParticipants;
      }
    } else {
      this.isEditMode = false;
      this.resetReunion();
    }
    if (this.participants.length > 0) {
      this.forceCleanParticipants();
    }
    // console.log('Participants FINAUX dans openModal:', [...this.participants]);
    // console.log('=== FIN openModal ===');

    this.cdr.markForCheck();
  }

  closeModal(): void {
    this.showModal = false;
    this.resetReunion();
    this.participants = [];
    this.currentStep = 0;
    this.steps = ['Détails', 'Participants', 'Récapitulatif'];
    this.cdr.markForCheck();
  }

  resetReunion(): void {
    this.reunion = {
      libelle: '',
      description: '',
      lieu: '',
      longitudeLieu: '',
      latitudeLieu: '',
      date: '',
      firstDate: '',
      lastDate: '',
      typeSeance: '',
      //heure: '',
      heureDebut: '',
      heureFin: '',
      ordre: '',
      directionId: 0,
      isSeanceMultiple: false,
      isPublic: false,
    };
  }

  editParticipant(index: number): void {
    this.backupData = { ...this.participants[index] };
    this.participants[index].editing = true;
  }

  saveParticipant(index: number): void {
    this.participants[index].editing = false;
  }

  cancelEdit(index: number): void {
    this.participants[index] = { ...this.backupData };
    this.participants[index].editing = false;
  }

  addParticipant(): void {
    const hasContent =
      this.newParticipant.nom.trim() ||
      this.newParticipant.prenoms.trim() ||
      this.newParticipant.email.trim() ||
      this.newParticipant.telephone.trim() ||
      this.newParticipant.fonction.trim();

    if (!hasContent) {
      this.utilitiesService.showNotification(
        'Veuillez remplir au moins un champ pour le participant',
        'error'
      );
      return;
    }

    if (this.newParticipant.email.trim()) {
      const participantExists = this.participants.some(
        (p) =>
          p.email &&
          p.email.toLowerCase().trim() ===
            this.newParticipant.email.toLowerCase().trim()
      );

      if (participantExists) {
        this.utilitiesService.showNotification(
          'Un participant avec cet email existe déjà',
          'error'
        );
        return;
      }
    }

    if (
      !this.newParticipant.email.trim() &&
      this.newParticipant.nom.trim() &&
      this.newParticipant.prenoms.trim()
    ) {
      const duplicateByName = this.participants.some(
        (p) =>
          p.nom.toLowerCase().trim() ===
            this.newParticipant.nom.toLowerCase().trim() &&
          p.prenoms.toLowerCase().trim() ===
            this.newParticipant.prenoms.toLowerCase().trim()
      );

      if (duplicateByName) {
        this.utilitiesService.showNotification(
          'Un participant avec ce nom et prénom existe déjà',
          'error'
        );
        return;
      }
    }

    const participantToAdd = {
      nom: this.newParticipant.nom.trim(),
      prenoms: this.newParticipant.prenoms.trim(),
      email: this.newParticipant.email.trim(),
      telephone: this.newParticipant.telephone.trim(),
      fonction: this.newParticipant.fonction.trim(),
      societe: this.newParticipant.societe?.trim() || '',
      isMail: this.newParticipant.isMail || false,
      editing: false,
    };

    this.participants.push(participantToAdd);

    this.newParticipant = {
      nom: '',
      prenoms: '',
      email: '',
      telephone: '',
      fonction: '',
      societe: '',
      isMail: false,
      editing: false,
    };

    this.showAddParticipantForm = false;
    this.cdr.markForCheck();
  }

  private cleanParticipantsBeforeSave(): any[] {
    return this.participants
      .filter((p) => {
        return (
          p.nom?.trim() ||
          p.prenoms?.trim() ||
          p.email?.trim() ||
          p.telephone?.trim() ||
          p.fonction?.trim()
        );
      })
      .map((p) => ({
        nom: p.nom?.trim() || '',
        prenoms: p.prenoms?.trim() || '',
        telephone: p.telephone?.trim() || '',
        email: p.email?.trim() || '',
        fonction: p.fonction?.trim() || '',
        societe: p.societe?.trim() || '',
      }));
  }

  removeParticipant(index: number): void {
    this.participants.splice(index, 1);
    this.cdr.markForCheck();
  }

  saveReunion(): void {
    if (!this.validateCurrentStep()) return;

    // console.log('=== DÉBUT saveReunion ===');
    // console.log('Mode édition:', this.isEditMode);
    // console.log('Participants à sauvegarder:', [...this.participants]);

    this.loading = true;

    const formattedDate = this.formatDate(this.reunion.date);
    const formattedLastDate = this.formatDate(this.reunion.lastDate);
    const formattedFirstDate = this.formatDate(this.reunion.firstDate);
    const directionId =
      this.currentUser?.directionId || this.reunion.directionId || null;

    const participantsToSave = this.participants
      .filter((p) => {
        const hasContent =
          p.nom?.trim() ||
          p.prenoms?.trim() ||
          p.email?.trim() ||
          p.telephone?.trim() ||
          p.fonction?.trim();
        return hasContent;
      })
      .map((p) => ({
        nom: (p.nom || '').toString().trim(),
        prenoms: (p.prenoms || '').toString().trim(),
        telephone: (p.telephone || '').toString().trim(),
        email: (p.email || '').toString().trim(),
        fonction: (p.fonction || '').toString().trim(),
        societe: (p.societe || '').toString().trim(),
        isMail: p.isMail || false,
      }));

    // console.log('Participants après nettoyage final:', participantsToSave);

    const requestData = {
      datas: [
        {
          id: this.isEditMode ? this.reunion.id : null,
          libelle: this.reunion.libelle,
          description: this.reunion.description,
          lieu: this.reunion.lieu,
          longitudeLieu: this.reunion.longitudeLieu || null,
          firstDate: formattedFirstDate,
          lastDate: formattedLastDate,
          latitudeLieu: this.reunion.latitudeLieu || null,
          date: formattedDate,
          rayonValidite: this.reunion.rayonValidite,
          typeSeance: this.reunion.typeSeance,
          ordreDuJour: this.reunion.ordreDuJour,
          heureDebut: this.reunion.heureDebut
            ? this.reunion.heureDebut + ':00'
            : null,
          heureFin: this.reunion.heureFin
            ? this.reunion.heureFin + ':00'
            : null,
          isSeanceMultiple: this.reunion.isSeanceMultiple,
          isPublic: this.reunion.isPublic,
          directionId: directionId,
          participants: participantsToSave,
        },
      ],
      user: this.currentUser.id,
      isSimpleLoading: false,
    };

    console.log('Données envoyées à lAPI:', requestData);

    const endpoint = this.isEditMode ? 'seance/update' : 'seance/create';
    console.log('Endpoint utilisé:', endpoint);

    this.restClient
      .post(endpoint, requestData)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: (res: any) => {
          // console.log('=== RÉPONSE API saveReunion ===');
          // console.log('Réponse complète:', res);

          if (!res.hasError) {
            this.itemToSave = res.items?.[0] || {};
            // console.log('Item sauvegardé:', this.itemToSave);

            if (this.itemToSave.participants) {
              console.log(
                'Participants dans la réponse:',
                this.itemToSave.participants
              );
            }

            this.utilitiesService.showNotification(
              `Réunion ${this.isEditMode ? 'modifiée' : 'créée'} avec succès`,
              'success'
            );
            this.showConfirmationStep();
            
            setTimeout(() => {
              this.getSeance();
            }, 100);
          } else {
            const apiErrorMessage =
              res.status?.message ||
              "Une erreur est survenue lors de l'opération";
            this.utilitiesService.showNotification(apiErrorMessage, 'error');
          }
          console.log('=== FIN RÉPONSE API ===');
        },
        error: (err: HttpErrorResponse) => {
          console.error('=== ERREUR API ===');
          console.error('Erreur complète:', err);
          console.error('Erreur body:', err.error);

          let errorMessage =
            "Une erreur s'est produite lors de l'enregistrement de la réunion";

          if (err.error?.status) {
            errorMessage = err.error.status.message;
          } else if (err.error?.message) {
            errorMessage = err.error.message;
          } else if (err.message) {
            errorMessage = err.message;
          }

          this.utilitiesService.showNotification(errorMessage, 'error');
        },
      });
  }

  private forceCleanParticipants(): void {
    if (!this.participants || this.participants.length === 0) return;

    console.log('=== NETTOYAGE FORCÉ ===');
    console.log('Participants avant nettoyage:', [...this.participants]);

    const seen = new Set();
    const uniqueParticipants = [];

    for (const participant of this.participants) {
      let key = '';
      if (participant.email && participant.email.trim()) {
        key = participant.email.toLowerCase().trim();
      } else if (participant.nom && participant.prenoms) {
        key = `${participant.nom.toLowerCase().trim()}_${participant.prenoms
          .toLowerCase()
          .trim()}`;
      } else {
        key = `${participant.nom || ''}_${participant.prenoms || ''}_${
          participant.telephone || ''
        }_${participant.fonction || ''}`.toLowerCase();
      }

      if (!seen.has(key)) {
        seen.add(key);
        uniqueParticipants.push(participant);
      } else {
        console.log('Participant dupliqué éliminé:', participant);
      }
    }

    this.participants = uniqueParticipants;
    console.log('Participants après nettoyage forcé:', [...this.participants]);
    console.log('=== FIN NETTOYAGE FORCÉ ===');
  }
  showConfirmationStep(): void {
    const tempSteps = [...this.steps, 'Confirmation'];
    this.steps = tempSteps;
    this.currentStep = 3;
    this.cdr.markForCheck();
  }

  filterNumbers(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[0-9]/g, '');
    this.reunion.longitudeLieu = input.value;
  }
  getSeance(resetPagination: boolean = false) {
    if (this.isLoading) return;

    if (
      this.dateDebut &&
      this.dateFin &&
      new Date(this.dateDebut) > new Date(this.dateFin)
    ) {
      this.utilitiesService.showNotification(
        'La date de début ne peut pas être postérieure à la date de fin',
        'error'
      );
      return;
    }

    this.isLoading = true;

    if (resetPagination || this.isSearching()) {
      this.currentPage = 0;
    }

    let dateDebutFormatted = null;
    let dateFinFormatted = null;

    if (this.dateDebut) {
      dateDebutFormatted = this.formatDateISO(this.dateDebut);
    }

    if (this.dateFin) {
      dateFinFormatted = this.formatDateISO(this.dateFin);
    }

    if (dateFinFormatted && !dateDebutFormatted) {
      const prevDay = new Date(this.dateFin);
      prevDay.setDate(prevDay.getDate() - 2);
      dateDebutFormatted = this.formatDateISO(prevDay);
    }

    interface RequestData {
      dateDebut: string | null;
      dateFin: string | null;
      isDeleted: boolean;
      lieu?: string;
      searchTerm?: string;
      status?: string;
      
      [key: string]: any;
    }

    const data: RequestData = {
      dateDebut: dateDebutFormatted,
      dateFin: dateFinFormatted,
      isDeleted: false,
    };

    if (this.itemToSearch?.lieu) {
      data.lieu = this.itemToSearch.lieu;
    }

    if (this.itemToSearch?.searchTerm) {
      data.searchTerm = this.itemToSearch.searchTerm;
    }

    if (this.itemToSearch?.status && this.itemToSearch.status !== 'TOUT') {
      data.status = this.itemToSearch.status;
    }
if (this.itemToSearch?.searchTerm) {
      data.searchTerm = this.itemToSearch.searchTerm;
    }


    const request: any = {
      index: this.currentPage,
      size: this.itemsPerPage,
      isSimpleLoading: false,
      user: this.currentUser.id,
      data: data,
    };

    this.restClient
      .post('seance/getByCriteria', request)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.isLoading = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: (res: any) => {
          // console.log('=== RÉPONSE API getSeance ===');
          // console.log('Réponse complète:', res);
          this.totalItems = res.count;

          if (res?.items?.length > 0) {
            res.items.forEach((item: any, index: number) => {
              // console.log(`Item ${index} - ID: ${item.id}:`, item);
              if (item.participants) {
                // console.log(
                //   `  -> Participants (${item.participants.length}):`,
                //   item.participants
                // );
              }
            });
          }

          this.itemsReunions = res?.items?.length > 0 ? res.items : [];
          // console.log('=== FIN RÉPONSE API ===');
          this.cdr.markForCheck();
        },
        error: (err) => {
          console.error('Erreur lors de la récupération des séances:', err);
          this.itemsReunions = [];
        },
      });

    this.cdr.markForCheck();
  }

  private isSearching(): boolean {
    return !!(
      this.itemToSearch?.lieu?.trim() ||
      (this.itemToSearch?.status && this.itemToSearch.status !== 'TOUT') ||
      this.dateDebut ||
      this.dateFin
    );
  }

  onSearchSeance() {
    this.getSeance(true);
  }

  formatDateISO(date: Date | string): string {
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      '0'
    )}-${String(d.getDate()).padStart(2, '0')}`;
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  exportToExcel(): void {
    if (!this.historiqueItems || this.historiqueItems.length === 0) {
      this.utilitiesService.showNotification(
        'Aucune donnée à exporter',
        'error'
      );
      return;
    }

    const exportData = this.historiqueItems.map((item, index) => {
      return {
        'N°': index + 1,
        Nom: item.nom || '-',
        Prénoms: item.prenoms || '-',
        Email: item.email || '-',
        Contact: item.telephone || '-',
        Société: item.societe || '-',
        Fonctions: item.fonction || '-',
      };
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Participants');

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const fileName = `liste_participants_${
      new Date().toISOString().split('T')[0]
    }.xlsx`;
    FileSaver.saveAs(data, fileName);

    this.utilitiesService.showNotification('Export Excel réussi', 'success');
  }

  exportToPDF(): void {
    if (!this.historiqueItems || this.historiqueItems.length === 0) {
      this.utilitiesService.showNotification(
        'Aucune donnée à exporter',
        'error'
      );
      return;
    }

    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text('Liste des participants', 14, 20);
    doc.setFontSize(11);
    doc.text(`Date d'export: ${new Date().toLocaleDateString()}`, 14, 30);

    const tableColumn = [
      'N°',
      'Nom',
      'Prénoms',
      'Email',
      'Contact',
      'Société',
      'Fonctions',
    ];
    const tableRows: any = [];

    this.historiqueItems.forEach((item, index) => {
      const itemData = [
        index + 1,
        item.nom || '-',
        item.prenoms || '-',
        item.email || '-',
        item.telephone || '-',
        item.societe || '-',
        item.fonction || '-',
      ];
      tableRows.push(itemData);
    });

    (doc as any).autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 40,
      theme: 'grid',
      styles: {
        fontSize: 8,
        cellPadding: 3,
        overflow: 'linebreak',
      },
      columnStyles: {
        0: { cellWidth: 10 },
        3: { cellWidth: 40 },
      },
      headStyles: {
        fillColor: [51, 51, 51],
        textColor: 255,
        fontStyle: 'bold',
      },
    });

    const fileName = `liste_participants_${
      new Date().toISOString().split('T')[0]
    }.pdf`;
    doc.save(fileName);

    this.utilitiesService.showNotification('Export PDF réussi', 'success');
  }

  saveNewSeanceDirectly(newSeance: any) {
    this.loading = true;

    const requestData = {
      datas: [newSeance],
      user: this.currentUser.id,
      isSimpleLoading: false,
    };

    requestData.datas = requestData.datas.map((seance) => ({
      id: null,
      seanceId: seance.seanceId,
      dateJour: seance.dateJour,
      description: seance.description,
      heureDebut: this.formatTime(seance.heureDebut),
      heureFin: this.formatTime(seance.heureFin),
    }));

    const endpoint = 'ordre-du-jour/create';

    this.restClient
      .post(endpoint, requestData)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: (res: any) => {
          if (!res.hasError) {
            this.utilitiesService.showNotification(
              'Nouvel ordre du jour ajouté avec succès',
              'success'
            );

            let savedSeance;

            const serverId =
              res.data?.id ||
              res.id ||
              res.items?.[0]?.id ||
              res.datas?.[0]?.id;

            if (serverId && typeof serverId === 'number' && serverId > 0) {
              savedSeance = {
                ...newSeance,
                id: serverId,
              };
              console.log('ID du serveur récupéré:', serverId);
            } else {
              console.warn(
                'Aucun ID valide retourné, rechargement des données...'
              );
              this.reloadSeancesAfterCreate(newSeance);
              this.resetForm();
              return;
            }

            this.seances.push(savedSeance);
            this.resetForm();
          } else {
            this.utilitiesService.showNotification(
              res.message || res.status?.message || "Erreur lors de l'ajout",
              'error'
            );
          }
        },
        error: (err) => {
          console.error('Erreur:', err);
          this.utilitiesService.showNotification(
            err.error?.message || err.message || 'Erreur inattendue',
            'error'
          );
        },
      });
  }

  reloadSeancesAfterCreate(newSeance: any) {
    const requestOrdre = {
      user: this.currentUser.id,
      data: {
        seanceId: newSeance.seanceId,
      },
      isSimpleLoading: false,
      index: 0,
      size: 100,
    };

    this.restClient
      .post('ordre-du-jour/getByCriteria', requestOrdre)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (result: any) => {
          const serverItems = result?.items || [];

          const matchingItem = serverItems.find(
            (item: any) =>
              item.dateJour === newSeance.dateJour &&
              item.heureDebut === this.formatTime(newSeance.heureDebut) &&
              item.heureFin === this.formatTime(newSeance.heureFin) &&
              item.description === newSeance.description
          );

          if (matchingItem) {
            this.seances.push({
              ...newSeance,
              id: matchingItem.id,
            });
            console.log('Élément ajouté avec ID serveur:', matchingItem.id);
          } else {
            this.seances.push({
              ...newSeance,
              id: null,
            });
            console.warn(
              "Impossible de récupérer l'ID serveur, élément ajouté sans ID"
            );
          }

          this.cdr.markForCheck();
        },
        error: (err) => {
          console.error('Erreur lors du rechargement:', err);
          this.seances.push({
            ...newSeance,
            id: null,
          });
          this.cdr.markForCheck();
        },
      });
  }
  saveSeance() {
    console.log('=== DEBUG saveSeance ===');
    console.log('this.seances avant traitement:', this.seances);

    if (this.seances.length === 0) {
      this.utilitiesService.showNotification(
        'Aucune séance à enregistrer',
        'error'
      );
      return;
    }

    const invalidSeances = this.seances.filter(
      (s) => !s.seanceId || s.seanceId === 0
    );

    this.loading = true;

    const seancesToUpdate = this.seances.filter((s) => {
      const hasValidId = typeof s.id === 'number' && s.id > 0;
      return hasValidId;
    });

    const seancesToCreate = this.seances.filter((s) => {
      return s.id === null || s.id === undefined || s.id === 0;
    });

    console.log('seancesToUpdate:', seancesToUpdate);
    console.log('seancesToCreate:', seancesToCreate);

    let requestData: any;
    let endpoint: string;

    if (this.isEditMode) {
      const allSeances = [
        ...seancesToUpdate.map((seance) => ({
          id: seance.id,
          seanceId: seance.seanceId,
          dateJour: seance.dateJour,
          description: seance.description,
          heureDebut: this.formatTime(seance.heureDebut),
          heureFin: this.formatTime(seance.heureFin),
          action: 'update',
        })),
        ...seancesToCreate.map((seance) => ({
          seanceId: seance.seanceId,
          dateJour: seance.dateJour,
          description: seance.description,
          heureDebut: this.formatTime(seance.heureDebut),
          heureFin: this.formatTime(seance.heureFin),
          action: 'create',
        })),
      ];

      requestData = {
        datas: allSeances,
        user: this.currentUser.id,
        isSimpleLoading: false,
      };

      endpoint =
        seancesToUpdate.length > 0
          ? 'ordre-du-jour/update'
          : 'ordre-du-jour/create';
    } else {
      requestData = {
        datas: this.seances.map((seance) => ({
          seanceId: seance.seanceId,
          dateJour: seance.dateJour,
          description: seance.description,
          heureDebut: this.formatTime(seance.heureDebut),
          heureFin: this.formatTime(seance.heureFin),
        })),
        user: this.currentUser.id,
        isSimpleLoading: false,
      };

      endpoint = 'ordre-du-jour/create';
    }

    console.log('Données finales envoyées:', requestData);
    console.log('Endpoint utilisé:', endpoint);

    this.restClient
      .post(endpoint, requestData)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: (res: any) => {
          if (!res.hasError) {
            const message = this.isEditMode
              ? 'Ordre du jour mis à jour avec succès'
              : 'Ordre du jour créé avec succès';

            this.utilitiesService.showNotification(message, 'success');
            this.closeModalSeanceMultiple();
          } else {
            this.utilitiesService.showNotification(
              res.message ||
                res.status?.message ||
                "Erreur lors de l'enregistrement",
              'error'
            );
          }
        },
        error: (err) => {
          console.error('Erreur:', err);
          this.utilitiesService.showNotification(
            err.error?.message || err.message || 'Erreur inattendue',
            'error'
          );
        },
      });
  }
}
